import { Typography } from "antd";

import { TABLE_TITLE_COLUMN_TEXT } from "@/constants/Typography";

const { Text } = Typography;

const TableTitleCell = ({ tooltip, maxWidth = undefined, children }) => {
  if (!children) return null;

  return (
    <Text
      ellipsis={{ tooltip }}
      style={{ maxWidth: maxWidth ?? TABLE_TITLE_COLUMN_TEXT.MAX_WIDTH }}
    >
      {children}
    </Text>
  );
};

export default TableTitleCell;
